module.exports = __webpack_public_path__ + "7d58a4ef020b94f90f530efa814170a3.png";